(function () {
  'use strict';

  var DESKTOP = '(min-width: 990px)';

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
  }

  /**
   * 桌面端把整排卡片锁定为「展开态最大高度」，这样悬浮切换（3 行 <-> 完整描述）
   * 时整排高度恒定，不会跳动。高度通过实测得到，自动适配任意文案长度。
   */
  function lockHeights(root) {
    if (!root) return;
    var list = root.querySelector('.wyg__list');
    if (!list) return;
    var cards = toArray(list.querySelectorAll('.wyg__card'));
    if (cards.length < 2) return;

    // 先清除旧的锁定高度，避免影响本次测量。
    cards.forEach(function (card) {
      card.style.height = '';
    });

    // 仅桌面横向排列时锁定；移动端纵向排列高度自适应，不存在跳动问题。
    if (!window.matchMedia(DESKTOP).matches) return;

    // 让每张卡片轮流进入「展开（变宽 + 完整描述）」状态，取其中最大的自然高度。
    root.classList.add('wyg--measuring');
    var maxHeight = 0;
    cards.forEach(function (target) {
      cards.forEach(function (card) {
        card.classList.toggle('wyg--measure-active', card === target);
      });
      var height = target.offsetHeight; // 读取强制重排，拿到当前布局高度。
      if (height > maxHeight) maxHeight = height;
    });
    cards.forEach(function (card) {
      card.classList.remove('wyg--measure-active');
    });
    root.classList.remove('wyg--measuring');

    // 用固定 height（配合卡片的 overflow: hidden）而非 min-height：
    // flex-grow 宽度过渡期间，正在展开的卡片文字换行更多、瞬时高度会超过最终值，
    // min-height 会被撑高导致整排跳动；固定 height 则把超出部分裁掉，外框恒定不跳。
    // +2px 余量避免最终态因亚像素取整被裁。
    if (maxHeight > 0) {
      var locked = maxHeight + 2;
      cards.forEach(function (card) {
        card.style.height = locked + 'px';
      });
    }
  }

  function initAll() {
    toArray(document.querySelectorAll('.wyg')).forEach(lockHeights);
  }

  var scheduled;
  function scheduleInit() {
    if (scheduled) cancelAnimationFrame(scheduled);
    scheduled = requestAnimationFrame(initAll);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }

  // 字体加载完成后重新测量（字体会影响换行行数与高度）。
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(initAll).catch(function () {});
  }

  window.addEventListener('resize', scheduleInit);

  // 主题编辑器：重新加载 section 时重新锁定。
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector ? event.target.querySelector('.wyg') : null;
    if (root) lockHeights(root);
  });
})();
